export const FONT_CONFIG = {
  family: "Helvetica",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/helveticaneue/v70/1Ptsg8zYS_SKggPNyC0IT4ttDfA.ttf",
      fontWeight: "normal",
    },
    {
      src: "https://fonts.gstatic.com/s/helveticaneue/v70/1Ptsg8zYS_SKggPNyC0IT4ttDfB.ttf",
      fontWeight: "bold",
    },
  ],
};

export const COMPANY_INFO = {
  name: "Yatrabiz",
  tagline: "Book Ahead. Fly Smart",
};

export const ALERT_MESSAGES = {
  nonRefundable: "Ticket is Non Refundable / Non Changeable / Non Cancellable.",
  covidUpdate:
    "COVID-19 UPDATE : WEB-CHECKIN is mandatory to board flight with applicable charges. Kindly contact your travel agent for more information.",
};

export const CONTACT_INFO = {
  company: "Arihant Tourism",
  address: "Vishal Nagar",
};

export const TERMS_AND_CONDITIONS = [
  "This group ticket is 100% Non Refundable, Non Changeable & Non Cancellable.",
  'Charged fare is totally agreed between "BUYER" & "SELLER", any issues related to fares thereafter will not be entertained.',
  "Check flight & passenger(s) details directly by logging / calling to the respective airlines in 24 hours prior to departure will not be entertained.",
  'No updates will be shared from our end in respect to flight cancellation / changes in timings. "BUYER" had to check directly with the respective airlines before departure.',
  "COVID-19 UPDATE: Web checkin is mandatory to board flight. Kindly contact your travel agent 24hr prior to departure.",
];

export const IMPORTANT_INFORMATION = [
  "Valid Govt. ID proof required at the time of Boarding.",
  "Free Baggage allowance is 15 Kg & Hand Baggage allowance is 7 Kg.",
  "Web Check-in Is Now Mandatory. Check In Online On The Airline Website.",
  "Disclaimer - No meal will be served on flights that have less than 2 hours of flight duration",
];

export const PDF_IMPORTANT_NOTES =
  "You have got an exclusive deal on the flight! These special fares are subject to specific terms and conditions whereby the names on the PNR reflect only within 24-72 hours before departure.";



export const PDF_LABELS = {
  passengerDetails: "PASSENGER DETAILS",
  flightDetails: "FLIGHT DETAILS",
  termsAndConditions: "TERMS AND CONDITIONS",
  importantInformation: "IMPORTANT INFORMATION",
  importantNotes: "Important Notes",
  baggage: "Baggage",
  meals: "Meals: At Extra Cost",
  generatedBy: (company) => `Generated by ${company} on`,
};
